import { Component } from '@angular/core';
import { environment } from '@environment/environment';

@Component({
	selector: 'soc-app',
	templateUrl: './app.component.html'
})
export class AppComponent {
	constructor() {
		document.getElementsByTagName('body')[0].id = environment.env;
	}
}
